export default "__VITE_ASSET__DU4PVndv__"